<template lang="pug">
  .container-edit-password-mobile(v-loading="loading")
    c-header
      template(slot="left")
        h3 修改密码
    .data-block
      data-row(label="旧密码", required)
        el-input(v-model="source.old_passwd", type="password")
    .data-block
      data-row(label="新密码", required)
        el-input(v-model="source.old_passwd", type="password")
      data-row(value-only) 密码长度应为 8 ~ 20 位
    .data-block
      data-row(label="重复新密码", required)
        el-input(v-model="source.new_passwd_2", type="password")
    
    el-button(type="primary", @click="editPassword").save-password 保存
</template>

<script>
export default {
  data () {
    return {
      source: {
        old_passwd:       null,
        new_passwd:       null,
        new_passwd_2:     null,
      },
      loading:  false,
    };
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo;
    },
  },
  methods: {
    editPassword () {
      if (!this.source.old_passwd) {
        this.$message({
          type:     'warning',
          message:  `请输入旧密码`
        });
        return;
      } else if (!this.source.new_passwd) {
        this.$message({
          type:     'warning',
          message:  `请输入新密码`
        });
        return;
      } else if (this.source.new_passwd.length < 8 || this.source.new_passwd.length > 20) {
        this.$message({
          type:     'warning',
          message:  `新密码长度应为 8 ~ 20 位`
        });
        return;
      } else if (this.source.new_passwd !== this.source.new_passwd_2) {
        this.$message({
          type:     'warning',
          message:  `两次输入的新密码不一致`
        });
        return;
      }

      this.loading = true;
      this.$store.dispatch('EDIT_PASSWORD', this.source).then(() => {
        this.$message({
          type:     'success',
          message:  '密码修改成功。稍后将返回登陆页面……'
        });

        setTimeout(() => {
          this.$store.dispatch('LOGOUT');
        }, 1000);
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `密码修改失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-edit-password-mobile {
  .save-password {
    .display-block;
    .margin-center;
    width:  200px;
  }
}
</style>